import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";

import Breadcrumb, { BreacrumbType } from "../breadcrumb/breadcrumb";
import { getFeatureLabel } from "../../utils/features";

import AddIcon from "../icons/Add";
import ArrowLeft from "../icons/ArrowLeft";
import PageSectionHeader from "../PageSectionHeader";

const FeatureLayout = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const params = useParams();
  const [breadcrumb, updateBreadcrumb] = useState<BreacrumbType[]>([]);

  useEffect(() => {
    if (params['*']) {
      const actualBreadcrumb = params["*"].split('/').map(path => {
        return {
          path: path,
          label: getFeatureLabel(intl, path) ?? path
        }
      });
      updateBreadcrumb(actualBreadcrumb);
    }
  }, [params, intl])
  

  return (
    <div className="relative h-full">
      <PageSectionHeader className="mb-0">
        <h1 className="py-2 flex items-center gap-4 rounded-md">
          <AddIcon className="w-5 h-5"/>
          <span className="text-shadow text-xl">
            {intl.formatMessage({ id: "home.addObject" })}
          </span>
        </h1>
      </PageSectionHeader>

      <div className="mt-14 mb-2 flex flex-col sm:flex-row gap-3 sm:items-center">
        {/* back */}
        <Link to="#" onClick={() => navigate(-1)}
          className="px-3 py-2 w-fit flex items-center gap-3
          border border-izygray rounded-md text-shadow text-sm">
          <ArrowLeft className="w-3" />
          <span>{intl.formatMessage({ id: "common.back" })}</span>
        </Link>

        {/* breadcrumb */}
        <Breadcrumb items={breadcrumb} startIndex={1}/>
      </div>

      {/* pages */}
      <Outlet />
    </div>
  )
}

export default FeatureLayout;
